import axios from "axios"
import { AI_SERVICE_URL } from "./constants"

export const aiServiceAxios = axios.create({
  baseURL: AI_SERVICE_URL,
  paramsSerializer: {
    indexes: null,
  },
})

export const chatAxios = axios.create({
  baseURL: AI_SERVICE_URL,
  adapter: "fetch",
  paramsSerializer: {
    indexes: null,
  },
})
